export interface DropdownOption {
  label: string;
  value: string;
}

export const CHANGE_TEAM_CONFIG = {
  cancel: 'Cancel',
  submit: 'Submit',
  title: 'Add/Change Team',
  comments: 'Comments',
  startDate: 'Start Date of New Project',
  endDate: 'End Date of Current Project',
  newProject: 'New Product',
  oldProject: 'Current Product',
  success: 'SUCCESS',
  error: 'Error',
};
